<div class="review-invoices">
  @for (payable of (selectedPayables$ | async); track payable.arTranId) {
    <div class="mt--100 review-invoices__item" data-cy="multi-invoice-div">
      <app-invoice-card
        [invoiceTableDataObject]="payable"
        (removed)="removePayable($event)"
        data-cy="multi-invoice-card-app"
      ></app-invoice-card>
    </div>
  }
</div>
